import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.3.1_db0@0.3.2_eslint@8.57.0_ioredis@5._c0a1e660fe67abdfc47f541cb7aa99ba/node_modules/nuxt/dist/pages/runtime/validate.js";
import a_45set_45tenant_45global from "/vercel/path0/base/middleware/a.set_tenant.global.ts";
import b_45auth_45global from "/vercel/path0/base/middleware/b.auth.global.ts";
import a_45handen_45redirect_45global from "/vercel/path0/volunteerly/middleware/a.handen-redirect.global.ts";
import c_45preload_45global from "/vercel/path0/volunteerly/middleware/c.preload.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.3.1_db0@0.3.2_eslint@8.57.0_ioredis@5._c0a1e660fe67abdfc47f541cb7aa99ba/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  a_45set_45tenant_45global,
  b_45auth_45global,
  a_45handen_45redirect_45global,
  c_45preload_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}